import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Box, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { useState } from 'react';
import { DetailsTable } from '../../components/DOAAuditReportComponents/DetailsTable';
import { Legend } from '../../components/DOAAuditReportComponents/Legend';
import { MainContainer } from "../../components/MainContainerComp";
import { PlateModal } from '../../components/PlateModal';
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { CheckboxFilter, IDetail } from "./UnionAuditReportData";
import { checkBoxStyle, filterContainerStyle, legendContentStyle, legendStyle } from "./styled";

interface IUnionAuditReportResultsDetailsProps {
  selectedDispatchInfo: string,
  data: IDetail[],
  filters: CheckboxFilter[],
  selectedFilters: number[],
  page: number,
  pageSize: number,
  onFilterSelect: (fitler: number) => void,
  onPageChange: (page: number) => void
}

export const UnionAuditReportResultsDetails: React.FC<IUnionAuditReportResultsDetailsProps> = ({
  selectedDispatchInfo, data, filters, selectedFilters, page, pageSize, onFilterSelect, onPageChange
}) => {
  const [showLegend, setShowLegend] = useState(false);
  const [regId, setRegId] = useState(0);
  const [board, setBoard] = useState('');
  const onShowLegend = () => setShowLegend(prev => !prev);

  const onOpenClosePlateModal = (regId = 0, board = '') => {
    setRegId(regId);
    setBoard(board);
  }

  return (
    <MainContainer>
      <Typography 
        className='sub-title' 
        data-automation="selected-shift-lbl"
      >
        {selectedDispatchInfo}
      </Typography>
      <Typography 
        sx={{pt: 1}}
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <Grid container sx={filterContainerStyle}>
          {filters.map((option, i) =>
            <Grid key={i} item xs={12} sm={6}>
              <FormControlLabel
                label={option.label}
                data-automation="filter-lbl"
                control={
                  <Checkbox
                    sx={checkBoxStyle}
                    checked={selectedFilters.includes(option.key)}
                    onClick={() => onFilterSelect(option.key)}
                    inputProps={{
                      "data-automation": "filters-checkbox"
                    } as React.InputHTMLAttributes<HTMLInputElement>}
                  />
                }
              />
            </Grid>
          )}
          <Grid item xs={12} sx={{ position: 'relative' }}>
            {showLegend &&
              <Box sx={legendContentStyle}>
                <Legend
                  isCasual={false}
                  handleClick={onShowLegend}
                />
              </Box>
            }
            <Box onClick={onShowLegend} sx={legendStyle} data-automation="legend-btn">Legend <FormatListBulletedIcon /></Box>
          </Grid>
        </Grid>
        <ScrollIndicatorsComp>
          <DetailsTable
            isCasual={false}
            data={data}
            page={page}
            pageSize={pageSize}
            onOpenClosePlateModal={onOpenClosePlateModal}
            onPageChange={onPageChange}
          />
        </ScrollIndicatorsComp>
      </Typography>
      {board && regId && <PlateModal
        onClose={() => onOpenClosePlateModal()}
        open={!!regId && !!board}
        board={board}
        id={Number(regId)}
      />}
    </MainContainer>
  )
}